var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "damagempsreason"
  }, [_c('b-card', [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.tableItems.length))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "isViewHidden": true,
      "isEditHidden": true,
      "isViewImage": true,
      "items": _vm.tableItems,
      "innerTableHeader": _vm.innerTableColumn,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ShowDamageMPSImages = false
      }
    },
    model: {
      value: (_vm.ShowDamageMPSImages),
      callback: function($$v) {
        _vm.ShowDamageMPSImages = $$v
      },
      expression: "ShowDamageMPSImages"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isImageLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isImageLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("Damage MPS Images ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDamageMPSImages
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Uploaded Images\n                          "), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("(Click on the image to view it)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.imagearray), function(item) {
    return _c('div', {
      staticClass: "col-md-5"
    }, [_c('br'), _vm._v(" "), (item) ? _c('img', {
      staticStyle: {
        "cursor": "pointer",
        "width": "65px",
        "margin-left": "9rem",
        "height": "65px"
      },
      attrs: {
        "src": item,
        "alt": "NO Image",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item) ? _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "1rem",
        "margin-left": "20px",
        "margin-right": "10px",
        "margin-top": "1rem"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Image"
      },
      on: {
        "click": function($event) {
          _vm.fileview(item)
        }
      }
    }) : _vm._e()])
  }))])])], 1)], 1), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.image
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.image)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.caption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.image,
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fbcbd75","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/DamageMPS/markdamageMPSListing/DamageMPSDetails/damagempsdetails.component.html
// module id = 1908
// module chunks = 3